// 경비지출 — 개인 지출(환급)·법인카드 사용을 한 청구서에 함께 담고, CEO 단일 결재(지급 확인도 CEO).
// 상태: 작성중 → 결재대기 → (개인 지출 있으면) 지급대기 → 완료 / 반려(작성자 수정 후 재제출)
export const EXPENSE_CATEGORIES = ['교통비', '주유·주차·통행료', '식대', '접대비', '숙박비', '소모품·사무용품', '도서·교육', '통신비', '택배·우편', '기타'];
export const PAY_METHODS = ['개인', '법인카드'];
export const EXPENSE_STATUS_LABELS = {
    draft: '작성중', submitted: '결재대기', approved: '지급대기', rejected: '반려', done: '완료',
};
/** 합계·기간·사용월 — 저장할 때마다 본문에서 다시 계산 */
export function expenseTotals(lines) {
    const dates = lines.map((l) => l.date).filter(Boolean).sort();
    const byCategory = {};
    let personal = 0;
    let card = 0;
    for (const l of lines) {
        if (l.method === '개인')
            personal += l.amount;
        else
            card += l.amount;
        byCategory[l.category] = (byCategory[l.category] ?? 0) + l.amount;
    }
    return {
        month: (dates[0] ?? '').slice(0, 7), firstDate: dates[0] ?? '', lastDate: dates[dates.length - 1] ?? '',
        total: personal + card, personal, card, byCategory, lineCount: lines.length,
    };
}
/** 승인 후 상태 — 환급할 개인 지출이 있으면 지급대기, 법인카드만이면 바로 완료 */
export const statusAfterApproval = (personal) => (personal > 0 ? 'approved' : 'done');
//# sourceMappingURL=expense.js.map